import { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import LandingPage from './components/LandingPage'
import PresentationMode from './components/PresentationMode'
import CompanyHome from './components/company/CompanyHome'
import ServicePage from './components/company/ServicePage'
import { LanguageProvider } from './contexts/LanguageContext'
import './styles/App.css'

// The Waymining product page, wrapped so the PDF export / parallax target is preserved.
function WayminingProductPage() {
  return (
    <div className="App">
      <div className="parallax-bg"></div>
      <div id="landing-page-container">
        <LandingPage />
      </div>
    </div>
  )
}

function App() {
  const [startInPresentationMode, setStartInPresentationMode] = useState(false);

  useEffect(() => {
    // Check URL for presentation parameter (Waymining product demo)
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('presentation') === 'true') {
      setStartInPresentationMode(true);
      // Clean up URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  if (startInPresentationMode) {
    return (
      <LanguageProvider>
        <PresentationMode onExit={() => setStartInPresentationMode(false)} />
      </LanguageProvider>
    );
  }

  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CompanyHome />} />
          <Route path="/waymining" element={<WayminingProductPage />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  )
}

export default App
